export enum NodeEnv {
    localhost="development",
    jestTest="test"
}
